import Vue from "vue";

/* Important to register plugins before importing App */
import "@/plugins";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import { config } from "dotenv";
import axios from "axios";

import "@/utils/theme";
import "@/assets/styles/tailwind.css";
import "@/plugins/unregisterServiceWorkers";
//import "@/plugins/preventRefresh";

Vue.config.productionTip = false;
config();

class AudioConfigs {
	private initialized = false;

	private welcome: HTMLAudioElement = new Audio();
	private prepareForVerification: HTMLAudioElement = new Audio();
	private prepareForSelfie: HTMLAudioElement = new Audio();
	private chooseCountry: HTMLAudioElement = new Audio();
	private chooseDocument: HTMLAudioElement = new Audio();
	private turnHead: HTMLAudioElement = new Audio();
	private enterTrn: HTMLAudioElement = new Audio();
	private enterPassport: HTMLAudioElement = new Audio();
	private passportReadability: HTMLAudioElement = new Audio();
	private passportFailed: HTMLAudioElement = new Audio();

	private licenceFront: HTMLAudioElement = new Audio();
	private licenceFrontReadability: HTMLAudioElement = new Audio();
	private licenceFrontFailed: HTMLAudioElement = new Audio();

	private licenceBack: HTMLAudioElement = new Audio();
	private licenceBackReadability: HTMLAudioElement = new Audio();
	private licenceBackFailed: HTMLAudioElement = new Audio();

	private uploadIsCompleted: HTMLAudioElement = new Audio();

	private typeOfNationalId: HTMLAudioElement = new Audio();
	private nationalIdFront: HTMLAudioElement = new Audio();
	private nationalIdFrontReadability: HTMLAudioElement = new Audio();
	private nationalIdFrontFailed: HTMLAudioElement = new Audio();

	private nationalIdBack: HTMLAudioElement = new Audio();
	private nationalIdBackReadability: HTMLAudioElement = new Audio();
	private nationalIdBackFailed: HTMLAudioElement = new Audio();

	constructor(initialize = false) {
		(async () => {
			if (initialize) {
				await this.initialize();
				console.log("Voice instructions initialized.");
			} else {
				console.log("Not using voice instructions.");
			}
		})();
	}

	private async initialize() {
		this.initialized = true;
	}

	async playWelcome() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			const filename = "welcome.mp3";
			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/welcome.mp3`;

			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/welcome.mp3`;
			}

			try {
				console.log(filePath, "Inside 1");
				const response = await axios.head(filePath);
				const { headers } = response;
				if (headers["content-type"] !== "audio/mpeg") {
					throw new Error("Not Found");
				}
				this.welcome = new Audio(filePath);
				if (this.checkIfMobile()) {
					this.welcome = new Audio(
						`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/welcome.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filePath}' not found.`);
				console.log(filePath, "Inside 2");
				console.log(filePath);
				filePath = `${process.env.VUE_APP_BASE_URL}audio/welcome.mp3`;
				try {
					await axios.head(filePath);
					this.welcome = new Audio(filePath);
				} catch (error) {
					console.log(filePath, "Inside 3");
					console.error(`File '${filename}' not found.`);
				}
			}

			await this.welcome.play();
			console.log("playing welcome");
		}
		return;
	}

	async playPrepareForVerification() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			const filename = "prepareForVerification.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/prepareForVerification.mp3`;

			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/prepareForVerification.mp3`;
			}
			try {
				const response = await axios.head(filePath);
				const { headers } = response;
				if (headers["content-type"] !== "audio/mpeg") {
					throw new Error("Not Found");
				}
				console.log(filePath, "Inside 4");
				this.prepareForVerification = new Audio(
					`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/prepareForVerification.mp3`
				);
				if (this.checkIfMobile()) {
					this.prepareForVerification = new Audio(
						`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/prepareForVerification.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filePath}' not found.`);
				console.log(filePath, "Inside 5");
				filePath = `${process.env.VUE_APP_BASE_URL}audio/prepareForVerification.mp3`;
				console.log(filePath);
				try {
					await axios.head(filePath);
					this.prepareForVerification = new Audio(filePath);
				} catch (error) {
					console.log(filePath, "Inside 6");
					console.error(`File '${filePath}' not found.`);
				}
			}
			await this.prepareForVerification.play();
			console.log("playing prepareForVerification");
		}
		return;
	}

	async playPrepareForSelfie() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			const filename = "prepareForSelfie.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/prepareForSelfie.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/prepareForSelfie.mp3`;
			}
			try {
				const response = await axios.head(filePath);
				const { headers } = response;
				if (headers["content-type"] !== "audio/mpeg") {
					throw new Error("Not Found");
				}
				this.prepareForSelfie = new Audio(
					`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/prepareForSelfie.mp3`
				);
				if (this.checkIfMobile()) {
					this.prepareForSelfie = new Audio(
						`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/prepareForSelfie.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
				filePath = `${process.env.VUE_APP_BASE_URL}audio/prepareForSelfie.mp3`;

				try {
					await axios.head(filePath);
					this.prepareForSelfie = new Audio(filePath);
				} catch (error) {
					console.error(`File '${filename}' not found.`);
				}
			}

			await this.prepareForSelfie.play();
			console.log("playing prepareForSelfie");
		}
		return;
	}

	async playTurnHead(direction) {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		let fileName = "";
		if (this.initialized) {
			switch (direction) {
				case "right":
					fileName = "turnHeadRight.mp3";
					break;
				case "left":
					fileName = "turnHeadLeft.mp3";
					break;
			}
			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/${fileName}`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/${fileName}`;
			}
			try {
				await axios.head(filePath);
				this.turnHead = new Audio(`/audio/${publicKey}/${fileName}`);
				if (this.checkIfMobile()) {
					this.prepareForSelfie = new Audio(
						`audio/${publicKey}/mobile/${fileName}`
					);
				}

				await this.turnHead.play();

				console.log(`playing turn head ${direction}`);
			} catch (error) {
				console.error(`File '${filePath}' not found.`);
			}
		}
		return;
	}

	async playChooseCountry() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.chooseCountry = new Audio("/audio/chooseCountry.mp3");
			const filename = "chooseCountry.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/chooseCountry.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/chooseCountry.mp3`;
			}
			try {
				const response = await axios.head(filePath);
				const { headers } = response;
				if (headers["content-type"] !== "audio/mpeg") {
					throw new Error("Not Found");
				}
				this.chooseCountry = new Audio(
					`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/chooseCountry.mp3`
				);
				if (this.checkIfMobile()) {
					this.chooseCountry = new Audio(
						`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/chooseCountry.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
				filePath = `${process.env.VUE_APP_BASE_URL}audio/chooseCountry.mp3`;

				try {
					await axios.head(filePath);
					this.chooseCountry = new Audio(filePath);
				} catch (error) {
					console.error(`File '${filename}' not found.`);
				}
			}
			await this.chooseCountry.play();
			console.log("playing chooseCountry");
		}
		return;
	}

	async playChooseDocument() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.chooseDocument = new Audio("/audio/chooseDocument.mp3");
			const filename = "chooseDocument.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/chooseDocument.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/chooseDocument.mp3`;
			}
			try {
				const response = await axios.head(filePath);
				const { headers } = response;
				if (headers["content-type"] !== "audio/mpeg") {
					throw new Error("Not Found");
				}
				this.chooseDocument = new Audio(
					`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/chooseDocument.mp3`
				);
				if (this.checkIfMobile()) {
					this.chooseDocument = new Audio(
						`${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/chooseDocument.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
				filePath = `${process.env.VUE_APP_BASE_URL}audio/chooseDocument.mp3`;

				try {
					await axios.head(filePath);
					this.chooseDocument = new Audio(filePath);
				} catch (error) {
					console.error(`File '${filename}' not found.`);
				}
			}
			await this.chooseDocument.play();
			console.log("playing chooseDocument");
		}
		return;
	}

	async playEnterTrn() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.enterTrn = new Audio("/audio/enterTrn.mp3");
			const filename = "enterTrn.mp3";

			const filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/enterTrn.mp3`;
			try {
				await axios.head(filePath);
				this.enterTrn = new Audio(`/audio/${publicKey}/enterTrn.mp3`);
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.enterTrn.play();
			console.log("playing enter Trn");
		}
		return;
	}

	async playUploadPassport() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.enterPassport = new Audio("/audio/uploadPassport.mp3");
			const filename = "uploadPassport.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/uploadPassport.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/uploadPassport.mp3`;
			}
			try {
				await axios.head(filePath);
				this.enterPassport = new Audio(
					`/audio/${publicKey}/uploadPassport.mp3`
				);

				if (this.checkIfMobile()) {
					this.enterPassport = new Audio(
						`/audio/${publicKey}/mobile/uploadPassport.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.enterPassport.play();
			console.log("playing enter Upload Passport");
		}
		return;
	}

	async playPassportReadability() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.passportReadability = new Audio(
				"/audio/passportReadability.mp3"
			);
			const filename = "passportReadability.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/passportReadability.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/passportReadability.mp3`;
			}
			try {
				await axios.head(filePath);
				this.passportReadability = new Audio(
					`/audio/${publicKey}/passportReadability.mp3`
				);

				if (this.checkIfMobile()) {
					this.passportReadability = new Audio(
						`/audio/${publicKey}/mobile/passportReadability.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.passportReadability.play();
			console.log("playing enter Passport Readability");
		}
		return;
	}

	async playPassportFailed() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.passportFailed = new Audio("/audio/passportUploadFailed.mp3");
			const filename = "passportUploadFailed.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/passportUploadFailed.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/passportUploadFailed.mp3`;
			}
			try {
				await axios.head(filePath);
				this.passportFailed = new Audio(
					`/audio/${publicKey}/passportUploadFailed.mp3`
				);

				if (this.checkIfMobile()) {
					this.passportFailed = new Audio(
						`/audio/${publicKey}/mobile/passportUploadFailed.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.passportFailed.play();
			console.log("playing enter Passport Failed");
		}
		return;
	}

	async playLicenceFront() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.licenceFront = new Audio("/audio/licenceFront.mp3");
			const filename = "licenceFront.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/licenceFront.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/licenceFront.mp3`;
			}
			try {
				await axios.head(filePath);
				this.licenceFront = new Audio(
					`/audio/${publicKey}/licenceFront.mp3`
				);
				if (this.checkIfMobile()) {
					this.licenceFront = new Audio(
						`/audio/${publicKey}/mobile/licenceFront.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.licenceFront.play();
			console.log("playing enter Licence Front");
		}
		return;
	}

	async playLicenceFrontReadability() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.licenceFrontReadability = new Audio(
				"/audio/licenceFrontReadability.mp3"
			);
			const filename = "licenceFrontReadability.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/licenceFrontReadability.mp3`;

			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/licenceFrontReadability.mp3`;
			}
			try {
				await axios.head(filePath);
				this.licenceFrontReadability = new Audio(
					`/audio/${publicKey}/licenceFrontReadability.mp3`
				);
				if (this.checkIfMobile()) {
					this.licenceFrontReadability = new Audio(
						`/audio/${publicKey}/mobile/licenceFrontReadability.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.licenceFrontReadability.play();
			console.log("playing enter Licence Front Readability");
		}
		return;
	}

	async playLicenceFrontFailed() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.licenceFrontFailed = new Audio(
				"/audio/licenceFrontFailed.mp3"
			);
			const filename = "licenceFrontFailed.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/licenceFrontFailed.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/licenceFrontFailed.mp3`;
			}
			try {
				await axios.head(filePath);
				this.licenceFrontFailed = new Audio(
					`/audio/${publicKey}/licenceFrontFailed.mp3`
				);
				if (this.checkIfMobile()) {
					this.licenceFrontFailed = new Audio(
						`/audio/${publicKey}/mobile/licenceFrontFailed.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.licenceFrontFailed.play();
			console.log("playing enter Licence Front Failed");
		}
		return;
	}

	async playLicenceBack() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.licenceBack = new Audio("/audio/licenceBack.mp3");
			const filename = "licenceBack.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/licenceBack.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/licenceBack.mp3`;
			}
			try {
				await axios.head(filePath);
				this.licenceBack = new Audio(
					`/audio/${publicKey}/licenceBack.mp3`
				);
				if (this.checkIfMobile()) {
					this.licenceBack = new Audio(
						`/audio/${publicKey}/mobile/licenceBack.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.licenceBack.play();
			console.log("playing enter Licence Back");
		}
		return;
	}

	async playLicenceBackFailed() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.licenceBackFailed = new Audio("/audio/licenceBackFailed.mp3");
			const filename = "licenceBackFailed.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/licenceBackFailed.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/licenceBackFailed.mp3`;
			}
			try {
				await axios.head(filePath);
				this.licenceBackFailed = new Audio(
					`/audio/${publicKey}/licenceBackFailed.mp3`
				);
				if (this.checkIfMobile()) {
					this.licenceBackFailed = new Audio(
						`/audio/${publicKey}/mobile/licenceBackFailed.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.licenceBackFailed.play();
			console.log("playing enter Licence Back Failed");
		}
		return;
	}

	async playUploadIsCompleted() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.uploadIsCompleted = new Audio("/audio/uploadCompleted.mp3");
			const filename = "uploadCompleted.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/uploadCompleted.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/uploadCompleted.mp3`;
			}
			try {
				await axios.head(filePath);
				this.uploadIsCompleted = new Audio(
					`/audio/${publicKey}/uploadCompleted.mp3`
				);
				if (this.checkIfMobile()) {
					this.licenceBackFailed = new Audio(
						`/audio/${publicKey}/mobile/uploadCompleted.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.uploadIsCompleted.play();
			console.log("playing enter Upload Complete");
		}
		return;
	}

	async playTypeOfNationalId() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.typeOfNationalId = new Audio("/audio/typeOfNationalId.mp3");
			const filename = "typeOfNationalId.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/typeOfNationalId.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/typeOfNationalId.mp3`;
			}
			try {
				await axios.head(filePath);
				this.typeOfNationalId = new Audio(
					`/audio/${publicKey}/typeOfNationalId.mp3`
				);
				if (this.checkIfMobile()) {
					this.typeOfNationalId = new Audio(
						`/audio/${publicKey}/mobile/typeOfNationalId.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.typeOfNationalId.play();
			console.log("playing National Id Type");
		}
		return;
	}

	async playNationalIdFront() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.nationalIdFront = new Audio("/audio/nationalIdFront.mp3");
			const filename = "nationalIdFront.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/nationalIdFront.mp3`;

			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/nationalIdFront.mp3`;
			}
			try {
				await axios.head(filePath);
				this.nationalIdFront = new Audio(
					`/audio/${publicKey}/nationalIdFront.mp3`
				);
				if (this.checkIfMobile()) {
					this.nationalIdFront = new Audio(
						`/audio/${publicKey}/mobile/nationalIdFront.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.nationalIdFront.play();
			console.log("playing National Id Front");
		}
		return;
	}

	async playNationalIdFrontReadability() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.nationalIdFrontReadability = new Audio(
				"/audio/nationalIdFrontReadability.mp3"
			);
			const filename = "nationalIdFrontReadability.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/nationalIdFrontReadability.mp3`;

			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/nationalIdFrontReadability.mp3`;
			}
			try {
				await axios.head(filePath);
				this.nationalIdFrontReadability = new Audio(
					`/audio/${publicKey}/nationalIdFrontReadability.mp3`
				);
				if (this.checkIfMobile()) {
					this.nationalIdFrontReadability = new Audio(
						`/audio/${publicKey}/mobile/nationalIdFrontReadability.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.nationalIdFrontReadability.play();
			console.log("playing National Id Front Readability");
		}
		return;
	}

	async playNationalIdFrontFailed() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.nationalIdFrontFailed = new Audio(
				"/audio/nationalIdFrontFailed.mp3"
			);
			const filename = "nationalIdFrontFailed.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/nationalIdFrontFailed.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/nationalIdFrontFailed.mp3`;
			}
			try {
				await axios.head(filePath);
				this.nationalIdFrontFailed = new Audio(
					`/audio/${publicKey}/nationalIdFrontFailed.mp3`
				);
				if (this.checkIfMobile()) {
					this.nationalIdFrontFailed = new Audio(
						`/audio/${publicKey}/mobile/nationalIdFrontFailed.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.nationalIdFrontFailed.play();
			console.log("playing National Id Front Failed");
		}
		return;
	}

	async playNationalIdBack() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.nationalIdBack = new Audio("/audio/nationalIdBack.mp3");
			const filename = "nationalIdBack.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/nationalIdBack.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/nationalIdBack.mp3`;
			}
			try {
				await axios.head(filePath);
				this.nationalIdBack = new Audio(
					`/audio/${publicKey}/nationalIdBack.mp3`
				);
				if (this.checkIfMobile()) {
					this.nationalIdBack = new Audio(
						`/audio/${publicKey}/mobile/nationalIdBack.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.nationalIdBack.play();
			console.log("playing National Id Back");
		}
		return;
	}

	async playNationalIdBackReadability() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.nationalIdBackReadability = new Audio(
				"/audio/nationalIdBackReadability.mp3"
			);
			const filename = "nationalIdBackReadability.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/nationalIdBackReadability.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/nationalIdBackReadability.mp3`;
			}
			try {
				await axios.head(filePath);
				this.nationalIdBackReadability = new Audio(
					`/audio/${publicKey}/nationalIdBackReadability.mp3`
				);
				if (this.checkIfMobile()) {
					this.nationalIdBackReadability = new Audio(
						`/audio/${publicKey}/mobile/nationalIdBackReadability.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.nationalIdBackReadability.play();
			console.log("playing National Id Back Readability");
		}
		return;
	}

	async playNationalIdBackFailed() {
		const params = new URLSearchParams(window.location.search);
		const publicKey = params.get("publicKey");
		if (this.initialized) {
			this.nationalIdBackFailed = new Audio(
				"/audio/nationalIdBackFailed.mp3"
			);
			const filename = "nationalIdBackFailed.mp3";

			let filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/nationalIdBackFailed.mp3`;
			if (this.checkIfMobile()) {
				filePath = `${process.env.VUE_APP_BASE_URL}audio/${publicKey}/mobile/nationalIdBackFailed.mp3`;
			}
			try {
				await axios.head(filePath);
				this.nationalIdBackFailed = new Audio(
					`/audio/${publicKey}/nationalIdBackFailed.mp3`
				);
				if (this.checkIfMobile()) {
					this.nationalIdBackFailed = new Audio(
						`/audio/${publicKey}/mobile/nationalIdBackFailed.mp3`
					);
				}
			} catch (error) {
				console.error(`File '${filename}' not found.`);
			}
			await this.nationalIdBackFailed.play();
			console.log("playing National Id Back Failed");
		}
		return;
	}

	stopWelcome() {
		if (this.initialized) {
			this.welcome.pause();
			this.welcome.currentTime = 0;
			console.log("stopping welcome");
		}
	}

	stopPrepareForVerification() {
		if (this.initialized) {
			this.prepareForVerification.pause();
			this.prepareForVerification.currentTime = 0;
			console.log("stopping prepareForVerification");
		}
	}

	stopPrepareForSelfie() {
		if (this.initialized) {
			this.prepareForSelfie.pause();
			this.prepareForSelfie.currentTime = 0;
			console.log("stopping prepareForSelfie");
		}
	}

	stopTurnHead() {
		if (this.initialized) {
			this.turnHead.pause();
			this.turnHead.currentTime = 0;
			console.log("stopping turn head");
		}
	}

	stopChooseCountry() {
		if (this.initialized) {
			this.chooseCountry.pause();
			this.chooseCountry.currentTime = 0;
			console.log("stopping chooseCountry");
		}
	}

	stopChooseDocument() {
		if (this.initialized) {
			this.chooseDocument.pause();
			this.chooseDocument.currentTime = 0;
			console.log("stopping chooseDocument.");
		}
	}

	stopEnterTrn() {
		if (this.initialized) {
			this.enterTrn.pause();
			this.enterTrn.currentTime = 0;
			console.log("stopping Enter Trn.");
		}
	}

	stopUploadPassport() {
		if (this.initialized) {
			this.enterPassport.pause();
			this.enterPassport.currentTime = 0;
			console.log("stopping Upload Passport.");
		}
	}

	stopPassportReadability() {
		if (this.initialized) {
			this.passportReadability.pause();
			this.passportReadability.currentTime = 0;
			console.log("stopping Passport Readability.");
		}
	}

	stopLicenceFront() {
		if (this.initialized) {
			this.licenceFront.pause();
			this.licenceFront.currentTime = 0;
			console.log("stopping Licence Front.");
		}
	}

	stopLicenceBack() {
		if (this.initialized) {
			this.licenceBack.pause();
			this.licenceBack.currentTime = 0;
			console.log("stopping Licence Back.");
		}
	}

	stopLicenceFrontFailed() {
		if (this.initialized) {
			this.licenceFront.pause();
			this.licenceFront.currentTime = 0;
			console.log("stopping Licence Front Failed.");
		}
	}

	stopLicenceBackFailed() {
		if (this.initialized) {
			this.licenceBackFailed.pause();
			this.licenceBackFailed.currentTime = 0;
			console.log("stopping Licence Back Failed.");
		}
	}

	stopLicenceFrontReadability() {
		if (this.initialized) {
			this.licenceFrontReadability.pause();
			this.licenceFrontReadability.currentTime = 0;
			console.log("stopping Licence Front.");
		}
	}

	stopPassportFailed() {
		if (this.initialized) {
			this.passportFailed.pause();
			this.passportFailed.currentTime = 0;
			console.log("stopping Passport Failed.");
		}
	}

	stopTypeOfNationalId() {
		if (this.initialized) {
			this.typeOfNationalId.pause();
			this.typeOfNationalId.currentTime = 0;
			console.log("stopping Type of National Id.");
		}
	}

	stopNationalIdFront() {
		if (this.initialized) {
			this.nationalIdFront.pause();
			this.nationalIdFront.currentTime = 0;
			console.log("stopping Type of National Id Front.");
		}
	}

	stopNationalIdFrontReadability() {
		if (this.initialized) {
			this.nationalIdFrontReadability.pause();
			this.nationalIdFrontReadability.currentTime = 0;
			console.log("stopping Type of National Id Front Readability.");
		}
	}

	stopNationalIdFrontFailed() {
		if (this.initialized) {
			this.nationalIdFrontFailed.pause();
			this.nationalIdFrontFailed.currentTime = 0;
			console.log("stopping Type of National Id Front Failed.");
		}
	}

	stopNationalIdBack() {
		if (this.initialized) {
			this.nationalIdBack.pause();
			this.nationalIdBack.currentTime = 0;
			console.log("stopping Type of National Id Back.");
		}
	}

	stopNationalIdBackFailed() {
		if (this.initialized) {
			this.nationalIdBackFailed.pause();
			this.nationalIdBackFailed.currentTime = 0;
			console.log("stopping Type of National Id Back Failed.");
		}
	}

	checkIfMobile() {
		const userAgent = navigator.userAgent;
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			userAgent
		);
	}
}

const params = new URLSearchParams(window.location.search);

Vue.prototype.$useAudioInstructions =
	params.get("useAudioInstructions") == "true";
//Vue.prototype.$useAudioInstructions = true; // temporary

Vue.prototype.$audioConfigs = new AudioConfigs(
	Vue.prototype.$useAudioInstructions
);

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
